/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/react";

export type ImgType = {
  src?: string;
  alt: string;
  customCSS?: string;
};

const Img: FC<ImgType> = (props) => {
  const { src, alt, customCSS } = props;

  const styles = css`
    ${customCSS}
  `;
  return <img src={src} alt={alt} css={styles} />;
};

export default Img;
